import {ref} from 'vue'

/**
 * Shared open state for the www cookie banner, so the footer's "Cookie preferences" link can
 * reopen it from outside the banner component. Module-level: the www site has one banner.
 */
const cookieBannerOpen = ref(false)

export function useCookieBanner() {
    const open = () => {
        cookieBannerOpen.value = true
    }
    const close = () => {
        cookieBannerOpen.value = false
    }

    return {cookieBannerOpen, open, close}
}
